import megatron from 'megatron';

export const getHotelDetailsData = ({url}) => {
    const headers = {
      
    };
    const type = 'GET';
    const credentials = 'include';
    const name = 'details hermes';
    return megatron({
        url,
        name,
        type,
        headers,
        credentials
    });
}
